import {
    SET_SUMMARY_SCENARIO_TABLES_REQUEST,
    SET_SUMMARY_SCENARIO_TABLES_SUCCESS,
    SET_SUMMARY_SCENARIO_TABLES_ERROR,
} from "./../../constants/kpiSummaryDashboardEnhancement/kpiSummaryScenarioTablesConstants";

const iState = {
    loading: false,
    successSummaryScenarioTablesData: {},
    successSummaryScenarioTablesDataCount: 0,
    error: "",
    message: "",
};

export default (state = iState, action) => {
    switch (action.type) {
        case SET_SUMMARY_SCENARIO_TABLES_REQUEST:
            return {
                loading: true,
                successSummaryScenarioTablesData: {},
                successSummaryScenarioTablesDataCount: 0,
                error: "",
                message: "",
            };
        case SET_SUMMARY_SCENARIO_TABLES_SUCCESS:
            return {
                loading: false,
                successSummaryScenarioTablesData: action.successSummaryScenarioTablesData,
                successSummaryScenarioTablesDataCount: action.successSummaryScenarioTablesDataCount,
                error: "",
                message: "",
            };
        case SET_SUMMARY_SCENARIO_TABLES_ERROR:
            return {
                loading: false,
                successSummaryScenarioTablesData: {},
                successSummaryScenarioTablesDataCount: 0,
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
